import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

export type StatTone = "default" | "warning" | "success";

export interface HubStat {
  label: string;
  value: string | number;
  icon: LucideIcon;
  tone?: StatTone;
}

const toneClasses: Record<StatTone, string> = {
  default: "bg-primary/10 text-primary",
  warning: "bg-amber-100 text-amber-700",
  success: "bg-green-100 text-green-700",
};

// At-a-glance shift numbers for floor staff. Purely presentational — the caller
// decides which stats are relevant to the current role.
const ShiftStats = ({ stats }: { stats: HubStat[] }) => {
  if (stats.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {stats.map(({ label, value, icon: Icon, tone = "default" }) => (
        <div
          key={label}
          className="flex items-center gap-3 rounded-xl border border-border bg-card p-4"
        >
          <span
            className={cn(
              "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg",
              toneClasses[tone]
            )}
          >
            <Icon className="h-5 w-5" />
          </span>
          <div className="min-w-0">
            <p className="text-xl font-bold leading-tight tabular-nums text-card-foreground">
              {value}
            </p>
            <p className="truncate text-xs text-muted-foreground">{label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShiftStats;
